import template from './billable-time-report.html';
import controller from './billable-time-report.controller';

let billableTimeReportComponent = {
  restrict: 'E',
  template,
  controller
};

export default billableTimeReportComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/reports/canned-reports/billable-time-report/billable-time-report.component.js